export const encodeBase64 = (data: any) => {
  const dataString = JSON.stringify(data);

  if (typeof window === 'undefined') return null;
  return window.btoa(dataString);
};
